/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-07 20:17:17
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2024-12-25 13:57:47
 */

//国际化
import http from '../httpConfig'

// 下载模板
export const downTemplate = (params) => {
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/download-module/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 基本信息导入
export const uploadHint = (params) => {
    return new Promise((resolve, reject) => {
        http
            .uploadFile('/api/language/upload-language-master/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

const table = 'mrbase_sys_language_master'

// 国际化提示信息列表
export const gethintList = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/list-language-master/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 国际化提示信息详情查询
export const gethintDetail = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/find-language-master/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 国际化提示信息删除
export const deletehint = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/delete-language-master/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 国际化提示信息添加修改
export const addehint = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/add-or-update-language-master/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// // 国际化提示信息添加修改
// export const updatehint = (params = {}) => {
//   params['~table~'] = table
//   return new Promise((resolve, reject) => {
//     http.post('/api/language/add-or-update-language-master/v1', params)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

//mrbase_sys_modules
//Value配置 国际化配置
const table2 = 'mrbase_sys_modules'
export const valuelist = (params = {}) => {
    params['~table~'] = table2
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/list-international-tables/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

//Value配置 国际化表单详情
export const valuedetail = (params = {}) => {
    // params['~table~'] = table2
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/list-international-fields-info/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

//Value配置 国际化表单更新
export const valueupdate = (params = {}) => {
    // params['~table~'] = table2
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/update-international-fields-info/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

//mrbase_sys_language_version
//label 国际化翻译
const table3 = 'mrbase_sys_language_version'
export const getLabelList = (params = {}) => {
    params['~table~'] = table3
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/list-language-version/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// label国际化翻译新增的 级联list接口
export const getAddList = (params = {}) => {
    params['~table~'] = table3
    return new Promise((resolve, reject) => {
        http
            .post(
                '/api/lable_internationalization/list_lable_internationalization/v1',
                params
            )
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// label 国际化翻译 详情列表的接口
export const labelVersionList = (params = {}) => {
    params['~table~'] = table3
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/auto-get-language-version/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 根据表名获取需要国际化的字段

export const getNationFields = (params = {}) => {
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/list-international-fields/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 保存 label 翻译
export const saveLabelTranslate = (params = {}) => {
    params['~table~'] = 'mrbase_sys_language_values'
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/add-or-update-language-version/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 删除 一条国际化数据 /delete-language-master/{version}
export const delNationalData = (params = {}) => {
    params['~table~'] = 'mrbase_sys_language_values'
    return new Promise((resolve, reject) => {
        http
            .post('/api/language/delete-language-value/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 获取公司语言列表

export const languageList = (params = {}) => {
        // params['~table~'] = 'mrbase_sys_language_values'
        // 登录之前调
        let api = '/api/language/login-language/v1'
        if (params.org_level_uuid) {
            // 登录之后调
            api = '/api/language/list-language-company/v1'
        }
        return new Promise((resolve, reject) => {
            //xupengcheng updatetime 2021年1月12日20:10:19 更改登录获取语言接口名
            http
                .post(api, params)
                .then((res) => {
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }
    // 切换语言调接口更改默认语言
export const editDefaultLang = (params = {}) => {
    // params['~table~'] = 'mrbase_sys_language_values'
    return new Promise((resolve, reject) => {
        http
            .post('/api/user/language/update-language/v1', params)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// // 根据切换的语言获取切换的语言  language_code
// export const getCurrentList = (params = {}) => {
//   params['~table~'] = 'mrbase_sys_language_master'
//   return new Promise((resolve, reject) => {
//     http.post('/api/lable_internationalization/list_lable_international/v1', params)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

//
// 根据切换的语言获取切换的语言  language_code
export const getCurrentList = (params = {}) => {
    params['~table~'] = 'mrbase_sys_language_master'
    return new Promise((resolve, reject) => {
        http
            .post(
                '/api/lable_internationalization/list_lable/v1',
                params
            )
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}